/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListWidgetsSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type ListWidgetsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListWidgetsSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListWidgetsSecurity$outboundSchema: z.ZodMiniType<
  ListWidgetsSecurity$Outbound,
  ListWidgetsSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listWidgetsSecurityToJSON(
  listWidgetsSecurity: ListWidgetsSecurity,
): string {
  return JSON.stringify(
    ListWidgetsSecurity$outboundSchema.parse(listWidgetsSecurity),
  );
}

/** @internal */
export type ListWidgetsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListWidgetsRequest$outboundSchema: z.ZodMiniType<
  ListWidgetsRequest$Outbound,
  ListWidgetsRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function listWidgetsRequestToJSON(
  listWidgetsRequest: ListWidgetsRequest,
): string {
  return JSON.stringify(
    ListWidgetsRequest$outboundSchema.parse(listWidgetsRequest),
  );
}
